import { IBaseUser } from 'src/app/core';
import { IDevice } from '../device';

export interface IDoctor extends IBaseUser {
  devices: IDevice[];
}
